"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockDexRouterFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "getAmountsIn",
        outputs: [
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
        ],
        name: "getAmountsOut",
        outputs: [
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapETHForExactTokens",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountOutMin",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountInMax",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapTokensForExactETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountOut",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountInMax",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "swapTokensForExactTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class MockDexRouterFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockDexRouterFactory = MockDexRouterFactory;
MockDexRouterFactory.bytecode = _bytecode;
MockDexRouterFactory.abi = _abi;
//# sourceMappingURL=MockDexRouterFactory.js.map